import { render, staticRenderFns } from "./BaseScheduledPNForm.vue?vue&type=template&id=b372f4e0&scoped=true&"
import script from "./BaseScheduledPNForm.vue?vue&type=script&lang=js&"
export * from "./BaseScheduledPNForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b372f4e0",
  null
  
)

export default component.exports